<div class="sidebar-area"
     [ngClass]="{'open-sidebar': open && displaySidebar, 'close-sidebar': !open && displaySidebar, 'no-sidebar': !displaySidebar}"
>
    <div class="sidebar" *ngIf="displaySidebar" [ngClass]="{'close-sidebar': !open}">
        <button class="btn" (click)="collapse()">
            <i class="fas" [ngClass]="{'fa-caret-left': open, 'fa-caret-right': !open}"></i>
        </button>

        <div class="logo-details">
            <img [src]="logo" alt="{{ 'label.logo' | translate }}" />
        </div>

        <div>
            <ul class="nav-list">
                <li class="profile mb-2">
                    <div class="profile-details"
                         tooltip="{{ open ? '' : userService.activeProfile?.nome }}"
                         placement="right"
                         (click)="changeOpenProfile()"
                    >
                        <div class="profile-img" *ngIf="!!userService.activeProfile?.imageUrl; else loading">
                            <img class="profile-img" [src]="userService.activeProfile?.imageUrl" />
                        </div>
                        <ng-template #loading>
                            <img class="profile-img" src="assets/img/loading.gif" />
                        </ng-template>
                        <div class="profile">
                            <div class="profile-title" *ngIf="!!userService.activeProfile?.nome; else waitingLoading">
                                {{ 'title.profile' | translate }}
                            </div>
                            <ng-template #waitingLoading>
                                <div class="profile-title w-150-px">{{ 'title.waitingLoadingProfile' | translate }}</div>
                            </ng-template>
                            <div class="profile-name">{{ userService.activeProfile?.nome }}</div>
                            <div class="profile-position">{{ userService.activeProfile?.cargo }}</div>
                        </div>
                        <i class="fas btn-down"
                           [ngClass]="{'fa-chevron-down': !openProfile, 'fa-chevron-up': openProfile}"
                        ></i>
                    </div>

                    <ul class="submenu" *ngIf="openProfile">
                        <li>
                            <div class="btn-link p-2">
                                <div class="links_name">
                                    <div class="title">{{ 'menu.changeLanguage' | translate }}</div>
                                    <div>
                                        <img class="flag mr-2"
                                             src="assets/img/languages/{{language.code}}.svg"
                                             (click)="languageService.setLanguageCode(language.code)"
                                             *ngFor="let language of languageService.getLanguages()"
                                        >
                                    </div>
                                </div>
                            </div>
                        </li>
                        <div class="separator"></div>
                        <li *ngFor="let item of profileMenu">
                            <button class="btn-link emphasis"
                                    type="button"
                                    (click)="navigate(item.link)"
                                    placement="right">
                                <div class="links_name">
                                    <div class="title">{{ item.description | translate }}</div>
                                </div>
                            </button>
                        </li>
                    </ul>
                </li>
                <li *ngIf="!this.authService.getCompleteRegistration()">
                    <div class="btn-link emphasis"
                         tooltip="{{ open ? '' : labelConsumption + ' '}} {{ consumptionPercent | percent:'1.1':'pt-br'}}">
                        <i class="fas fa-comment-dollar"></i>
                        <div class="links_name w-100">
                            <div class="title">{{ 'title.consumption' | translate }}</div>
                            <div class="progress w-100 bg-neural-1">
                                <div class="progress bg-semantic-green-600-light" [style.width.%]="consumptionPercent * 100"></div>
                            </div>
                            <div class="subtitle">{{ consumptionPercent | percent:'1.1':'pt-br'}} {{ 'label.used' | translate }}</div>
                        </div>
                    </div>
                </li>
                <ng-container *ngFor="let item of items; let i = index">
                    <ng-container *ngIf="i==0 || items[i-1].group !== item.group">
                        <div class="separator"></div>
                        <div class="menu-title">{{item.group}}</div>
                    </ng-container>
                    <li *hasPermission="item.permissions">
                        <button class="btn-link emphasis"
                                [ngClass]="{'selected': activeRoute === item.link}"
                                type="button"
                                (click)="navigate(item.link)"
                                tooltip="{{open ? '' : item.group + ' - '}}{{ open ? '' : item.description | translate }}"
                                placement="right"
                        >
                            <i class="{{item.icon}}"></i>
                            <div class="links_name">
                                <div class="title">{{ item.description | translate }}</div>
                            </div>
                        </button>
                    </li>
                </ng-container>
                <div class="separator"></div>
            </ul>

            <div class="menu-footer">
                <div class="separator"></div>
                <div class="item">
                    <a href="https://code7.com/wp-content/uploads/2021/04/Code7-Politica-de-Protecao-de-Dados.pdf-D4Sign.pdf" target="_blank">
                        <span>{{ 'label.privacyPolicy' | translate }}</span>
                    </a>
                </div>
                <div class="item py-0">
                    <span>{{ 'label.version' | translate }} {{ environment.version }}</span>
                </div>
            </div>
        </div>
    </div>
</div>

